module.exports = __webpack_public_path__ + "media/flags/bq-56a8eaed.svg";